import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const imagenesProyecto = [
  '/images/proyecto_1.jpeg',
  '/images/proyecto_2.jpeg',
  '/images/proyecto_3.jpeg',
  '/images/proyecto_4.jpeg'
];

const HomeProyectos = ({ temaActual }) => {
  const { t } = useTranslation();
  const [indiceCarrusel, setIndiceCarrusel] = useState(0);
  const slides = t('projects.slides', { returnObjects: true });

  useEffect(() => {
    const interval = setInterval(() => {
      setIndiceCarrusel((prev) => (prev + 1) % imagenesProyecto.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const cambiarSlide = (direccion) => {
    setIndiceCarrusel((indiceActual) =>
      (indiceActual + direccion + imagenesProyecto.length) % imagenesProyecto.length
    );
  };

  return (
    <section id="proyectos" className="py-20 px-4">
      <div className="container mx-auto">
        <div className="relative max-w-5xl mx-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={indiceCarrusel}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.5 }}
              className="relative overflow-hidden rounded-2xl bg-gray-900 shadow-2xl"
            >
              <img
                src={imagenesProyecto[indiceCarrusel]}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full scale-110 object-cover opacity-50 blur-2xl"
              />
              <div aria-hidden="true" className="absolute inset-0 bg-gray-950/30" />
              <img
                src={imagenesProyecto[indiceCarrusel]}
                alt={slides[indiceCarrusel].title}
                className="relative z-10 h-[400px] w-full object-contain md:h-[500px]"
              />
              <div className="absolute bottom-0 left-0 right-0 z-20 bg-gradient-to-t from-black/80 to-transparent p-8">
                {/*<span className={`mb-3 inline-block rounded-full px-3 py-1 text-sm font-semibold ${temaActual.badge}`}>
                  {t('projects.featured')}
                </span>
                 <h3 className="mb-2 text-2xl font-bold text-white md:text-3xl">
                  {slides[indiceCarrusel].title}
                </h3>
                <p className="text-lg text-gray-200">
                  {slides[indiceCarrusel].desc}
                </p> */}
              </div>
            </motion.div>
          </AnimatePresence>

          <button
            type="button"
            aria-label={t('projects.previous')}
            onClick={() => cambiarSlide(-1)}
            className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/20 p-3 text-white backdrop-blur-md transition-all hover:bg-white/40"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <button
            type="button"
            aria-label={t('projects.next')}
            onClick={() => cambiarSlide(1)}
            className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/20 p-3 text-white backdrop-blur-md transition-all hover:bg-white/40"
          >
            <ChevronRight className="h-6 w-6" />
          </button>

          <div className="mt-6 flex justify-center gap-3">
            {imagenesProyecto.map((_, index) => (
              <button
                key={imagenesProyecto[index]}
                type="button"
                onClick={() => setIndiceCarrusel(index)}
                aria-label={t('projects.slideLabel', { number: index + 1 })}
                aria-current={index === indiceCarrusel ? 'true' : undefined}
                className={`h-3 w-3 rounded-full transition-all ${
                  index === indiceCarrusel ? 'w-8 bg-blue-600' : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeProyectos;
